import React from "react";
import IntroSection from "./IntroSection";
import CareerSection from "./CareerSection";
import PortfolioSection from "./PortfolioSection";

const Main = () => {
  return (
    <main>
        <IntroSection />
        <CareerSection />
        <PortfolioSection />
    </main>
  );
};

export default Main;
